import React from 'react';

import { Helmet } from 'react-helmet-async';
import { Route, Routes, Navigate } from 'react-router-dom';

import { ResponsiveView } from '@liscio/ui';

import {
  NOTIFICATIONS_PAGE_TITLES,
  NOTIFICATIONS_PATHS,
} from './route-constants';
import { useFirmViewMode } from 'custom-hooks/useFirmViewMode';
import {
  DASHBOARD_DOMAIN,
  DASHBOARD_PATHS,
} from 'modules/dashboard/route-constants';

const ListViewDesktop = React.lazy(
  () => import('./views/ListViewDesktop/ListViewDesktop')
);

export const ModuleRoutes = () => {
  const { isMobile } = useFirmViewMode();
  const mobileRedirect = (
    <Navigate to={`/${DASHBOARD_DOMAIN}${DASHBOARD_PATHS.home}`} />
  );
  return (
    <>
      <Helmet title={NOTIFICATIONS_PAGE_TITLES.list} />
      <Routes>
        <Route
          path={NOTIFICATIONS_PATHS.list}
          element={
            <ResponsiveView
              SmallView={mobileRedirect}
              LargeView={isMobile ? mobileRedirect : <ListViewDesktop />}
            />
          }
        />
      </Routes>
    </>
  );
};

export default ModuleRoutes;
